export default __webpack_public_path__ + "static/media/House-keeping-01.50177d88.jpg";